export default {
  form: {
    owner_phone_number: {
      label: 'Telefoonnummer contactpersoon',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'E-mail contactpersoon',
      placeholder: 'E-mailadres invoeren',
    },
    owner_first_name: {
      label: 'Voornaam',
      placeholder: 'Voornaam invoeren',
    },
    owner_last_name: {
      label: 'Achternaam',
      placeholder: 'Achternaam invoeren',
    },
    owner_dob: {
      label: 'Geboortedatum',
      placeholder: 'Datum',
    },
    owner_id_number: {
      label: 'ID-nummer (bijv. burgerservicenummer in de VS)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Terug',
    next: 'Volgende',
  },
};
